// <auto-generated>
// This file is automatically generated from DSL.
// Do not modify this file directly. Changes will be overwritten.
// Generated: 2025-11-13T19:25:50.901Z
// </auto-generated>

import { lazy, Suspense } from 'react';

const AreaListView = lazy(() => import('@/core/AreaListView').then(m => ({ default: m.AreaListView })));
const AreaDetailView = lazy(() => import('@/core/AreaDetailView').then(m => ({ default: m.AreaDetailView })));
const AreaTypeListView = lazy(() => import('@/core/AreaTypeListView').then(m => ({ default: m.AreaTypeListView })));
const AreaTypeDetailView = lazy(() => import('@/core/AreaTypeDetailView').then(m => ({ default: m.AreaTypeDetailView })));
const AssignmentPolicyListView = lazy(() => import('@/core/AssignmentPolicyListView').then(m => ({ default: m.AssignmentPolicyListView })));
const AssignmentPolicyDetailView = lazy(() => import('@/core/AssignmentPolicyDetailView').then(m => ({ default: m.AssignmentPolicyDetailView })));
const BatchJobListView = lazy(() => import('@/core/BatchJobListView').then(m => ({ default: m.BatchJobListView })));
const BatchJobDetailView = lazy(() => import('@/core/BatchJobDetailView').then(m => ({ default: m.BatchJobDetailView })));
const BatchJobRunListView = lazy(() => import('@/core/BatchJobRunListView').then(m => ({ default: m.BatchJobRunListView })));
const BatchJobRunDetailView = lazy(() => import('@/core/BatchJobRunDetailView').then(m => ({ default: m.BatchJobRunDetailView })));
const BusinessRuleListView = lazy(() => import('@/core/BusinessRuleListView').then(m => ({ default: m.BusinessRuleListView })));
const BusinessRuleDetailView = lazy(() => import('@/core/BusinessRuleDetailView').then(m => ({ default: m.BusinessRuleDetailView })));
const CompanyProfileListView = lazy(() => import('@/core/CompanyProfileListView').then(m => ({ default: m.CompanyProfileListView })));
const CompanyProfileDetailView = lazy(() => import('@/core/CompanyProfileDetailView').then(m => ({ default: m.CompanyProfileDetailView })));
const CountryListView = lazy(() => import('@/core/CountryListView').then(m => ({ default: m.CountryListView })));
const CountryDetailView = lazy(() => import('@/core/CountryDetailView').then(m => ({ default: m.CountryDetailView })));
const CurrencyListView = lazy(() => import('@/core/CurrencyListView').then(m => ({ default: m.CurrencyListView })));
const CurrencyDetailView = lazy(() => import('@/core/CurrencyDetailView').then(m => ({ default: m.CurrencyDetailView })));
const DeliveryTermsListView = lazy(() => import('@/core/DeliveryTermsListView').then(m => ({ default: m.DeliveryTermsListView })));
const DeliveryTermsDetailView = lazy(() => import('@/core/DeliveryTermsDetailView').then(m => ({ default: m.DeliveryTermsDetailView })));
const DocumentPageSetupListView = lazy(() => import('@/core/DocumentPageSetupListView').then(m => ({ default: m.DocumentPageSetupListView })));
const DocumentPageSetupDetailView = lazy(() => import('@/core/DocumentPageSetupDetailView').then(m => ({ default: m.DocumentPageSetupDetailView })));
const DocumentTemplateListView = lazy(() => import('@/core/DocumentTemplateListView').then(m => ({ default: m.DocumentTemplateListView })));
const DocumentTemplateDetailView = lazy(() => import('@/core/DocumentTemplateDetailView').then(m => ({ default: m.DocumentTemplateDetailView })));
const EntityTemplateListView = lazy(() => import('@/core/EntityTemplateListView').then(m => ({ default: m.EntityTemplateListView })));
const EntityTemplateDetailView = lazy(() => import('@/core/EntityTemplateDetailView').then(m => ({ default: m.EntityTemplateDetailView })));
const EnumValueListView = lazy(() => import('@/core/EnumValueListView').then(m => ({ default: m.EnumValueListView })));
const EnumValueDetailView = lazy(() => import('@/core/EnumValueDetailView').then(m => ({ default: m.EnumValueDetailView })));
const FieldRestrictionSetListView = lazy(() => import('@/core/FieldRestrictionSetListView').then(m => ({ default: m.FieldRestrictionSetListView })));
const FieldRestrictionSetDetailView = lazy(() => import('@/core/FieldRestrictionSetDetailView').then(m => ({ default: m.FieldRestrictionSetDetailView })));
const LldDistrictListView = lazy(() => import('@/core/LldDistrictListView').then(m => ({ default: m.LldDistrictListView })));
const LldDistrictDetailView = lazy(() => import('@/core/LldDistrictDetailView').then(m => ({ default: m.LldDistrictDetailView })));
const NumberSeriesListView = lazy(() => import('@/core/NumberSeriesListView').then(m => ({ default: m.NumberSeriesListView })));
const NumberSeriesDetailView = lazy(() => import('@/core/NumberSeriesDetailView').then(m => ({ default: m.NumberSeriesDetailView })));
const OrgRoleFunctionListView = lazy(() => import('@/core/OrgRoleFunctionListView').then(m => ({ default: m.OrgRoleFunctionListView })));
const OrgRoleFunctionDetailView = lazy(() => import('@/core/OrgRoleFunctionDetailView').then(m => ({ default: m.OrgRoleFunctionDetailView })));
const OrgUnitListView = lazy(() => import('@/core/OrgUnitListView').then(m => ({ default: m.OrgUnitListView })));
const OrgUnitDetailView = lazy(() => import('@/core/OrgUnitDetailView').then(m => ({ default: m.OrgUnitDetailView })));
const OwnerDerivationRuleListView = lazy(() => import('@/core/OwnerDerivationRuleListView').then(m => ({ default: m.OwnerDerivationRuleListView })));
const OwnerDerivationRuleDetailView = lazy(() => import('@/core/OwnerDerivationRuleDetailView').then(m => ({ default: m.OwnerDerivationRuleDetailView })));
const PaymentTermsListView = lazy(() => import('@/core/PaymentTermsListView').then(m => ({ default: m.PaymentTermsListView })));
const PaymentTermsDetailView = lazy(() => import('@/core/PaymentTermsDetailView').then(m => ({ default: m.PaymentTermsDetailView })));
const ReceivingLocationListView = lazy(() => import('@/core/ReceivingLocationListView').then(m => ({ default: m.ReceivingLocationListView })));
const ReceivingLocationDetailView = lazy(() => import('@/core/ReceivingLocationDetailView').then(m => ({ default: m.ReceivingLocationDetailView })));
const SetupPackageListView = lazy(() => import('@/core/SetupPackageListView').then(m => ({ default: m.SetupPackageListView })));
const SetupPackageDetailView = lazy(() => import('@/core/SetupPackageDetailView').then(m => ({ default: m.SetupPackageDetailView })));
const TradeTypeListView = lazy(() => import('@/core/TradeTypeListView').then(m => ({ default: m.TradeTypeListView })));
const TradeTypeDetailView = lazy(() => import('@/core/TradeTypeDetailView').then(m => ({ default: m.TradeTypeDetailView })));
const UnitOfMeasureListView = lazy(() => import('@/core/UnitOfMeasureListView').then(m => ({ default: m.UnitOfMeasureListView })));
const UnitOfMeasureDetailView = lazy(() => import('@/core/UnitOfMeasureDetailView').then(m => ({ default: m.UnitOfMeasureDetailView })));
const PolicyConfigurationView = lazy(() => import('@/core/policies/PolicyConfigurationView.generated').then(m => ({ default: m.PolicyConfigurationView })));
const DynamicFieldsManagementView = lazy(() => import('@/core/DynamicFieldsManagementView').then(m => ({ default: m.DynamicFieldsManagementView })));

/**
 * Core Module Routes
 */
export const coreRoutes = [
{ path: '/core/areas',
element: <Suspense><AreaListView /></Suspense> },
{ path: '/core/areas/:id',
element: <Suspense><AreaDetailView /></Suspense> },
{ path: '/core/areatypes',
element: <Suspense><AreaTypeListView /></Suspense> },
{ path: '/core/areatypes/:id',
element: <Suspense><AreaTypeDetailView /></Suspense> },
{ path: '/core/assignmentpolicies',
element: <Suspense><AssignmentPolicyListView /></Suspense> },
{ path: '/core/assignmentpolicies/:id',
element: <Suspense><AssignmentPolicyDetailView /></Suspense> },
{ path: '/core/batchjobs',
element: <Suspense><BatchJobListView /></Suspense> },
{ path: '/core/batchjobs/:id',
element: <Suspense><BatchJobDetailView /></Suspense> },
{ path: '/core/batchjobruns',
element: <Suspense><BatchJobRunListView /></Suspense> },
{ path: '/core/batchjobruns/:id',
element: <Suspense><BatchJobRunDetailView /></Suspense> },
{ path: '/core/businessrules',
element: <Suspense><BusinessRuleListView /></Suspense> },
{ path: '/core/businessrules/:id',
element: <Suspense><BusinessRuleDetailView /></Suspense> },
{ path: '/core/companyprofiles',
element: <Suspense><CompanyProfileListView /></Suspense> },
{ path: '/core/companyprofiles/:id',
element: <Suspense><CompanyProfileDetailView /></Suspense> },
{ path: '/core/countries',
element: <Suspense><CountryListView /></Suspense> },
{ path: '/core/countries/:id',
element: <Suspense><CountryDetailView /></Suspense> },
{ path: '/core/currencies',
element: <Suspense><CurrencyListView /></Suspense> },
{ path: '/core/currencies/:id',
element: <Suspense><CurrencyDetailView /></Suspense> },
{ path: '/core/deliveryterms',
element: <Suspense><DeliveryTermsListView /></Suspense> },
{ path: '/core/deliveryterms/:id',
element: <Suspense><DeliveryTermsDetailView /></Suspense> },
{ path: '/core/documentpagesetups',
element: <Suspense><DocumentPageSetupListView /></Suspense> },
{ path: '/core/documentpagesetups/:id',
element: <Suspense><DocumentPageSetupDetailView /></Suspense> },
{ path: '/core/documenttemplates',
element: <Suspense><DocumentTemplateListView /></Suspense> },
{ path: '/core/documenttemplates/:id',
element: <Suspense><DocumentTemplateDetailView /></Suspense> },
{ path: '/core/entitytemplates',
element: <Suspense><EntityTemplateListView /></Suspense> },
{ path: '/core/entitytemplates/:id',
element: <Suspense><EntityTemplateDetailView /></Suspense> },
{ path: '/core/enumvalues',
element: <Suspense><EnumValueListView /></Suspense> },
{ path: '/core/enumvalues/:id',
element: <Suspense><EnumValueDetailView /></Suspense> },
{ path: '/core/fieldrestrictionsets',
element: <Suspense><FieldRestrictionSetListView /></Suspense> },
{ path: '/core/fieldrestrictionsets/:id',
element: <Suspense><FieldRestrictionSetDetailView /></Suspense> },
{ path: '/core/llddistricts',
element: <Suspense><LldDistrictListView /></Suspense> },
{ path: '/core/llddistricts/:id',
element: <Suspense><LldDistrictDetailView /></Suspense> },
{ path: '/core/numberseries',
element: <Suspense><NumberSeriesListView /></Suspense> },
{ path: '/core/numberseries/:id',
element: <Suspense><NumberSeriesDetailView /></Suspense> },
{ path: '/core/orgrolefunctions',
element: <Suspense><OrgRoleFunctionListView /></Suspense> },
{ path: '/core/orgrolefunctions/:id',
element: <Suspense><OrgRoleFunctionDetailView /></Suspense> },
{ path: '/core/orgunits',
element: <Suspense><OrgUnitListView /></Suspense> },
{ path: '/core/orgunits/:id',
element: <Suspense><OrgUnitDetailView /></Suspense> },
{ path: '/core/ownerderivationrules',
element: <Suspense><OwnerDerivationRuleListView /></Suspense> },
{ path: '/core/ownerderivationrules/:id',
element: <Suspense><OwnerDerivationRuleDetailView /></Suspense> },
{ path: '/core/paymentterms',
element: <Suspense><PaymentTermsListView /></Suspense> },
{ path: '/core/paymentterms/:id',
element: <Suspense><PaymentTermsDetailView /></Suspense> },
{ path: '/core/receivinglocations',
element: <Suspense><ReceivingLocationListView /></Suspense> },
{ path: '/core/receivinglocations/:id',
element: <Suspense><ReceivingLocationDetailView /></Suspense> },
{ path: '/core/setuppackages',
element: <Suspense><SetupPackageListView /></Suspense> },
{ path: '/core/setuppackages/:id',
element: <Suspense><SetupPackageDetailView /></Suspense> },
{ path: '/core/tradetypes',
element: <Suspense><TradeTypeListView /></Suspense> },
{ path: '/core/tradetypes/:id',
element: <Suspense><TradeTypeDetailView /></Suspense> },
{ path: '/core/unitofmeasures',
element: <Suspense><UnitOfMeasureListView /></Suspense> },
{ path: '/core/unitofmeasures/:id',
element: <Suspense><UnitOfMeasureDetailView /></Suspense> },
{ path: '/core/dynamic-fields', element: <Suspense><DynamicFieldsManagementView /></Suspense> },
{ path: '/core/policies', element: <Suspense><PolicyConfigurationView /></Suspense> }
];
